export default __webpack_public_path__ + "static/rws-logo2x-152439876c2d5e09f8b394f36a9b7011.png";